module.exports = __webpack_public_path__ + "img/5a7d1a603fd0fc8b0d4af6452bf10caf.svg";